/* ============================================
   SOS ATÖLYESİ — Shopify Theme JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- Mobile Menu ---- */
  const menuBtn = document.getElementById('mobile-menu-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open);
    });
  }

  /* ---- Nav Dropdown (hover + click fallback for mobile) ---- */
  document.querySelectorAll('.nav-dropdown').forEach(dropdown => {
    const trigger = dropdown.querySelector('.nav-dropdown__trigger');
    if (trigger) {
      trigger.addEventListener('click', () => {
        dropdown.classList.toggle('open');
      });
    }
  });
  document.addEventListener('click', e => {
    if (!e.target.closest('.nav-dropdown')) {
      document.querySelectorAll('.nav-dropdown.open').forEach(d => d.classList.remove('open'));
    }
  });

  /* ---- Cart Drawer ---- */
  const cartOpen = document.getElementById('cart-open');
  const cartClose = document.getElementById('cart-close');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartBody = document.getElementById('cart-body');
  const cartFooter = document.getElementById('cart-footer');
  const cartCount = document.getElementById('cart-count');
  const cartTotalPrice = document.getElementById('cart-total-price');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    if (cartOverlay) { cartOverlay.style.display = 'block'; }
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (cartOverlay) { cartOverlay.style.display = 'none'; }
    document.body.style.overflow = '';
  }
  if (cartOpen) cartOpen.addEventListener('click', openCartDrawer);
  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  function fetchCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        renderCartDrawer(cart);
        if (cartCount) cartCount.textContent = cart.item_count;
      });
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 0 }) + ' ₺';
  }

  function renderCartDrawer(cart) {
    if (!cartBody) return;
    if (cart.item_count === 0) {
      cartBody.innerHTML = '<p class="cart-empty">Sepetiniz boş.</p>';
      if (cartFooter) cartFooter.style.display = 'none';
      return;
    }
    if (cartFooter) cartFooter.style.display = 'block';
    if (cartTotalPrice) cartTotalPrice.textContent = formatMoney(cart.total_price);

    cartBody.innerHTML = cart.items.map(item => `
      <div class="cart-item" style="display:grid;grid-template-columns:72px 1fr;gap:14px;align-items:center;padding:14px;border:1px solid #e5e7e0;border-radius:12px;margin-bottom:12px;">
        <img src="${item.image}" alt="${item.title}" style="width:72px;height:72px;object-fit:cover;border-radius:8px;">
        <div>
          <p style="font-weight:600;font-size:0.9rem;color:#1a1a18;margin-bottom:4px;">${item.title}</p>
          <p style="color:#5a7a4a;font-weight:700;font-size:0.95rem;margin-bottom:8px;">${formatMoney(item.final_price)}</p>
          <div style="display:flex;align-items:center;gap:8px;">
            <button onclick="updateCartItem(${item.key.replace(/:/g, '__')}, ${item.quantity - 1})" style="width:28px;height:28px;border:1.5px solid #e5e7e0;border-radius:50%;display:flex;align-items:center;justify-content:center;background:none;cursor:pointer;font-size:1rem;">−</button>
            <span style="font-weight:600;font-size:0.9rem;">${item.quantity}</span>
            <button onclick="updateCartItem(${item.key.replace(/:/g, '__')}, ${item.quantity + 1})" style="width:28px;height:28px;border:1.5px solid #e5e7e0;border-radius:50%;display:flex;align-items:center;justify-content:center;background:none;cursor:pointer;font-size:1rem;">+</button>
            <button onclick="updateCartItem('${item.key}', 0)" style="font-size:0.75rem;color:#9ca3af;cursor:pointer;background:none;border:none;margin-left:4px;">Kaldır</button>
          </div>
        </div>
      </div>
    `).join('');
  }

  window.updateCartItem = function(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(r => r.json())
    .then(cart => {
      renderCartDrawer(cart);
      if (cartCount) cartCount.textContent = cart.item_count;
      if (cartTotalPrice) cartTotalPrice.textContent = formatMoney(cart.total_price);
    });
  };

  /* ---- Add to Cart (product cards + product page) ---- */
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.add-to-cart-btn');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.textContent = 'Eklendi ✓';
    btn.disabled = true;
    btn.style.background = '#7a9a6a';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => {
      fetchCart();
      openCartDrawer();
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
        btn.style.background = '';
      }, 2200);
    })
    .catch(() => {
      btn.textContent = originalText;
      btn.disabled = false;
      btn.style.background = '';
    });
  });

  /* ---- Product Page Form ---- */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const btn = document.getElementById('add-to-cart-btn');
      const formData = new FormData(productForm);
      const data = { id: formData.get('id'), quantity: parseInt(formData.get('quantity') || '1') };

      if (btn) { btn.textContent = 'Sepete Eklendi ✓'; btn.disabled = true; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
      .then(r => r.json())
      .then(() => {
        fetchCart();
        openCartDrawer();
        if (btn) {
          setTimeout(() => {
            btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> Sepete Ekle';
            btn.disabled = false;
          }, 2200);
        }
      });
    });
  }

  /* ---- Sticky Header Shadow ---- */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10 ? '0 2px 20px rgba(0,0,0,0.08)' : 'none';
    }, { passive: true });
  }

  /* ---- Collection Sort ---- */
  const sortSelect = document.getElementById('sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      const url = new URL(window.location);
      url.searchParams.set('sort_by', this.value);
      window.location = url.toString();
    });
  }

  /* ---- Cart Page Qty Controls ---- */
  document.querySelectorAll('.cart-page-qty-minus').forEach(btn => {
    btn.addEventListener('click', function() {
      const key = this.dataset.key;
      const qty = parseInt(this.dataset.qty) - 1;
      updateCartPageItem(key, qty);
    });
  });
  document.querySelectorAll('.cart-page-qty-plus').forEach(btn => {
    btn.addEventListener('click', function() {
      const key = this.dataset.key;
      const qty = parseInt(this.dataset.qty) + 1;
      updateCartPageItem(key, qty);
    });
  });
  function updateCartPageItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(() => window.location.reload());
  }

  /* Initial cart count fetch */
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => { if (cartCount) cartCount.textContent = cart.item_count; });

});
